import type { MFAttestationSummary } from "state/members/accessReviews";

/**
 * The attestation page headlines the RESOURCE being attested (PLO-5185
 * review): the system is what the attestor is being asked about, and the
 * campaign is only context. The two label decisions live here as pure
 * functions because the repo has no render tests.
 */

type WithNames = Pick<MFAttestationSummary, "resourceName" | "cycleName">;

export const attestationTitle = (att: WithNames): string =>
  att.resourceName || "All resources";

export const attestationSubtitle = (att: WithNames): string | null =>
  att.cycleName ? `Part of ${att.cycleName}` : null;
